import { ReactNode, useContext } from "react";

import { Skeleton } from "@chakra-ui/react";

import { Box, Flex } from "../../internal/exports";

import { ContributionContext } from "../context";

export function Tile({ children }: { children: ReactNode }) {
  const {
    isLoaded,
    imageSrc,
    showImage,
    hideTile,
    showFullTextContent,
    hideHeader,
    tileBackgroundColor = "gray.100"
  } = useContext(ContributionContext);

  if ((showImage && imageSrc) || hideTile) return <Box px={2}>{children}</Box>;

  if (!isLoaded)
    return (
      <Skeleton
        aspectRatio={16 / 9}
        maxH={265}
        borderTopRadius={hideHeader ? "md" : "none"}
      />
    );

  return (
    <Flex
      p={4}
      width="100%"
      height="100%"
      align="center"
      justify="center"
      bg={tileBackgroundColor}
      borderTopRadius={hideHeader ? "md" : "none"}
      minH={showFullTextContent ? 265 : undefined}
      aspectRatio={showFullTextContent ? undefined : 16 / 9}
    >
      <Box
        color={
          tileBackgroundColor === "gray.100"
            ? "blackAlpha.900"
            : "whiteAlpha.900"
        }
        css={{
          "& a": {
            color:
              tileBackgroundColor === "gray.100"
                ? "blackAlpha.900"
                : "whiteAlpha.900"
          }
        }}
      >
        {children}
      </Box>
    </Flex>
  );
}
